import * as Yup from 'yup';

export const formSchema = Yup.object().shape({
  workOrderStatusID: Yup.string().required('Status is required'),
});
